import * as qs from 'querystring';
import { Location } from 'history';

const searchToQuery = (location: Location) => {
  const querystring = location.search ? location.search.slice(1) : '';
  return qs.parse(querystring);
};

const stringifyQuery = (queryObj: any = {}) => {
  return qs.stringify(queryObj);
};

const parseQuery = (search?: string) => {
  const searchText = search || window.location.search;
  const querystring = searchText ? searchText.slice(1) : '';
  return qs.parse(querystring);
};

const mergeQuery = (location: Location, query: any) => {
  const oldQuery = searchToQuery(location);
  const newQuery = { ...oldQuery, ...query };
  const querystring = qs.stringify(newQuery);
  return `?${querystring}`;
};
export {
  searchToQuery,
  stringifyQuery,
  mergeQuery,
  parseQuery
};
